/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-14T15:25:43.953
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentLeaseContractSale,
	listRentLeaseContractSaleInit,
	listRentLeaseContractSaleByAuthorizations,
	deleteRentLeaseContractSale
} from '@api/rentmanage/RentLeaseContractSale';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentLeaseContractSale({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLeaseContractSale(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentLeaseContractSaleByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLeaseContractSaleByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentLeaseContractSaleInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentLeaseContractSaleInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
                        state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentLeaseContractSale({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentLeaseContractSale({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
